import Vue from "vue";
import VueRouter from "vue-router";
import CategoryPage from "@/views/CategoryPage.vue";
import ProductDetail from "@/views/ProductDetail.vue";
import ShoppingCart from "@/views/ShoppingCart.vue";
import OrderList from "@/views/OrderList.vue";
import OrderDetail from "@/views/OrderDetail.vue";
import OverviewDashboard from "@/views/OverviewDashboard.vue";
import HomePage from "@/views/HomePage.vue";
import EmailVerify from "@/views/VerifyAccount.vue";
import LoginPage from "@/views/LoginPage.vue";
import LogoutPage from "@/views/LogoutPage.vue";
import PublicProducts from "@/views/PublicProducts.vue";
import ProductForm from "@/views/ProductForm.vue";
import ProductList from "@/views/ProductList.vue";
import StorePage from "@/views/StorePage.vue";
import UserRegister from "@/views/UserRegister.vue";
import ShipmentManagement from "@/views/ShipmentManagement.vue";
import ShipmentList from "@/views/ShipmentList.vue";
import ShipmentForm from "@/views/ShipmentForm.vue";
import ShipmentGroup from "@/views/ShipmentGroup.vue";
import ShipmentGroupList from "@/views/ShipmentGroupList.vue";
import PrinterFriendly from "@/views/PrinterFriendly.vue";
import CustomerDetail from "@/views/CustomerDetail.vue";
import CustomerList from "@/views/CustomerList.vue";
import InvoiceForm from "@/views/InvoiceForm.vue";
import InvoiceList from "@/views/InvoiceList.vue";
import TrackingPage from "@/views/TrackingPage.vue";
import ContactUs from "@/views/ContactUs.vue";
import PageCode404 from "@/views/PageCode404.vue";
import ExpenseForm from "@/views/ExpenseForm.vue";
import ExpenseList from "@/views/ExpenseList.vue";
import PaymentPage from "@/views/PaymentPage.vue";
import PaymentList from "@/views/PaymentList.vue";
import DropdownSetting from "@/views/DropdownSetting.vue";
import StockList from "@/views/StockList.vue";
import StockForm from "@/views/StockForm.vue";
import VendorDetail from "@/views/VendorDetail.vue";
import VendorList from "@/views/VendorList.vue";
Vue.use(VueRouter);
const routes = [
  {
    path: "/",
    name: "HomePage",
    component: HomePage,
  },
  {
    path: "/tracking/:id",
    name: "TrackingPage",
    component: TrackingPage,
  },
  {
    path: "/login",
    name: "Login",
    component: LoginPage,
  },
  {
    path: "/logout",
    name: "Logout",
    component: LogoutPage,
  },

  {
    path: "/register/user",
    name: "UserRegister",
    component: UserRegister,
  },
  {
    path: "/verify/email/:sessionId",
    name: "EmailVerify",
    component: EmailVerify,
  },

  {
    path: "/public/products",
    name: "PublicProducts",
    component: PublicProducts,
  },

  {
    path: "/view/category/:id",
    name: "CategoryPage",
    component: CategoryPage,
  },

  {
    path: "/page/404",
    name: "Page404",
    component: PageCode404,
  },

  {
    path: "/shipment/management/",
    name: "ShipmentManagement",
    redirect: { name: "ShipmentList" },
    component: ShipmentManagement,
    beforeEnter: (to, from, next) => {
      let val = localStorage.getItem("isAdmin");
      if (val === "true") {
        next();
      } else {
        next("/page/404");
      }
    },
    children: [
      {
        path: "",
        name: "ShipmentList",
        component: ShipmentList,
      },
      {
        path: "new/shipment",
        name: "NewShipment",
        component: ShipmentForm,
      },
      {
        path: "update/shipment/:id",
        name: "ShipmentUpdate",
        component: ShipmentForm,
      },
      {
        path: "new/shipment/group",
        name: "NewShipmentGroup",
        component: ShipmentGroup,
      },
      {
        path: "update/shipment/group/:id",
        name: "ShipmentGroupUpdate",
        component: ShipmentGroup,
      },
      {
        path: "shipment/group/list",
        name: "ShipmentGroupList",
        component: ShipmentGroupList,
      },
      {
        path: "new/customer",
        name: "NewCustomer",
        component: CustomerDetail,
      },
      {
        path: "update/customer/:id",
        name: "CustomerUpdate",
        component: CustomerDetail,
      },
      {
        path: "customer/list",
        name: "CustomerList",
        component: CustomerList,
      },
      {
        path: "new/invoice",
        name: "NewInvoice",
        component: InvoiceForm,
        props: (route) => ({
          ...route.params,
        }),
      },
      {
        path: "update/invoice/:id",
        name: "InvoiceUpdate",
        component: InvoiceForm,
      },
      {
        path: "invoice/list",
        name: "InvoiceList",
        component: InvoiceList,
      },
      {
        path: "new/product",
        name: "NewProduct",
        component: ProductForm,
      },
      {
        path: "product/detail/:id",
        name: "ProductDetail",
        component: ProductDetail,
      },
      {
        path: "update/product/:id",
        name: "ProductUpdate",
        component: ProductForm,
      },
      {
        path: "product/list",
        name: "ProductList",
        component: ProductList,
      },
      {
        path: "store/page/",
        name: "Shipment.StorePage",
        component: StorePage,
      },
      {
        path: "cart",
        name: "Shipment.Cart",
        component: ShoppingCart,
      },
      {
        path: "orders",
        name: "Shipment.OrderList",
        component: OrderList,
      },
      {
        path: "order/:id",
        name: "Shipment.OrderDetail",
        component: OrderDetail,
      },
      {
        path: "contact/us",
        name: "Shipment.ContactUs",
        component: ContactUs,
      },
      {
        path: "printer/friendly/:id",
        name: "Shipment.PrinterFriendly",
        component: PrinterFriendly,
      },
      {
        path: "new/expense",
        name: "NewExpense",
        component: ExpenseForm,
        props: (route) => ({
          ...route.params,
        }),
      },
      {
        path: "expense/detail/:id",
        name: "ExpenseDetail",
        component: ExpenseForm,
      },
      {
        path: "expense/list",
        name: "ExpenseList",
        component: ExpenseList,
      },
      {
        path: "overview/dashboard",
        name: "OverviewDashboard",
        component: OverviewDashboard,
      },
      {
        path: "new/payment/:customerId",
        name: "PaymentPage",
        component: PaymentPage,
      },
      {
        path: "payment/list",
        name: "PaymentList",
        component: PaymentList,
      },
      {
        path: "dropdown/setting",
        name: "DropdownSetting",
        component: DropdownSetting,
      },
      {
        path: "new/stock",
        name: "NewStock",
        component: StockForm,
      },
      {
        path: "stock/list",
        name: "StockList",
        component: StockList,
      },
      {
        path: "vendor/detail/:id",
        name: "VendorDetail",
        component: VendorDetail,
      },
      {
        path: "vendor/list",
        name: "VendorList",
        component: VendorList,
      },
    ],
  },
];

const router = new VueRouter({
  routes,
});
export default router;
